<template>
    <div>
        <div class="filter-form" v-if="!offer_id">
            <el-row :gutter="20" >
                <el-col :span="4">
                    <label class="label">
                        {{ $t('name') }}
                    </label>
                    <el-input v-model="c.q"></el-input>
                </el-col>

                <el-col :span="4">
                    <el-button type="primary" @click="getStreams" icon="el-icon-search">{{ $t('search') }}</el-button>
                </el-col>
            </el-row>
        </div>

        <div class="mb15" v-if="!offer_id">
            <el-checkbox :label="$t('archive')" v-model="c.archive" true-label="1" false-label=""></el-checkbox>
        </div>

        <el-table
                v-loading="loading"
                :data="streams"
                style="width: 100%">
            <div slot="empty">
                <span v-if="!loading">{{ $t('el.table.emptyText') }}</span>
            </div>

            <el-table-column
                    prop="name"
                    :label="$t('name')">
            </el-table-column>

          <el-table-column
              :label="$t('link')">
            <template slot-scope="scope">
              <a :href="scope.row.tracking_link" v-if="scope.row.tracking_link" @click.prevent="getTrackingLink(scope.row)">{{scope.row.tracking_link}}{{scope.row.macros?'?':''}}{{scope.row.macros}}</a>
            </template>
          </el-table-column>

          <el-table-column
                    v-if="!offer_id"
                    prop="offer"
                    :label="$t('offer')">
                <template slot-scope="scope">
                    <div v-if="scope.row.offer" :class="{'text-muted123': scope.row.offer.status!=='active'}">
                        <router-link :to="{name: 'offer-view', params: { id: scope.row.offer.id }}" class="m-r-xs">
                            <img :src="scope.row.offer.logo" style="width: 60px"> {{scope.row.offer.name}}
                        </router-link>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                    prop="created_at"
                    :label="$t('created_at')"
                    width="180">
                <template slot-scope="scope">
                    {{ scope.row.created_at | moment("YYYY-MM-DD HH:mm") }}
                </template>
            </el-table-column>
            <el-table-column
                    width="180">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button size="small" type="primary" @click="getTrackingLink(scope.row)" :disabled="!scope.row.offer"><i class="material-icons">link</i></el-button>
                        <el-button size="small" @click="edit(scope.row)"><i class="material-icons">settings</i></el-button>
                        <el-button size="small" @click="remove(scope.row)" v-if="!scope.row.deleted_at"><i class="material-icons">delete</i></el-button>
                        <el-button size="small" @click="restore(scope.row)" v-if="scope.row.deleted_at"><i class="material-icons">restore_from_trash</i></el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="selectedItem.id ? $t('edit_stream'): $t('create_stream')" :visible.sync="dialogFormVisible" top="4vh">
            <StreamEdit :item="selectedItem" v-on:cancel="dialogFormVisible = false" v-on:update = "updateStream" v-on:create = "getStreams" />
        </el-dialog>

        <el-dialog :title="$t('link')" :visible.sync="dialogLinkVisible">
            <StreamLink :item="selectedItem" v-on:update = "updateStream" />
        </el-dialog>
    </div>
</template>

<script>
    import qs from 'qs';
    import StreamEdit from "./StreamEdit";
    import StreamLink from "./StreamLink";
    export default {
        name: "StreamItem",
        components: {StreamLink, StreamEdit},
        props: ['offer_id'],
        data () {
            return {
                streams: [],
                loading: false,
                dialogFormVisible: false,
                dialogLinkVisible: false,
                selectedItem: {},
                c: {}
            }
        },
        created () {
            this.getStreams()
        },
        methods: {
            getStreams () {
                this.loading = true;
                // includes=offer,landings
                if (this.offer_id) {
                    this.c.offer_id = this.offer_id;
                }
                this.$axios.get('/streams?' + qs.stringify({ expand: 'landings,offer', c: this.c }, { encode: false })).then((res) => {
                    this.streams = res.data;
                    this.loading = false;
                });
            },
            remove (model) {
                this.$confirm(this.$t('confirm_delete_stream'), this.$t('confirm_title'), {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    this.$axios.delete('/streams/' + model.id ).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.$t('notice.stream_deleted')
                        });
                        this.loading = false;
                        this.streams.splice(this.streams.indexOf(model), 1);
                    });
                });
            },
            edit (model) {
                this.dialogFormVisible=true;
                this.selectedItem={
                    id: model.id,
                    name: model.name,
                    landingIDs: model.landings.map(function(r) {
                        return r.id;
                    }),
                    offer_id: model.offer ? model.offer.id : null,
                    domain_id: model.domain ? model.domain.id : null,
                    postback_url: model.postback_url
                };
            },
            create (offer_id) {
                this.selectedItem = {
                    id: null,
                    name: '',
                    landingIDs: [],
                    offer_id: offer_id,
                    postback_url: ''
                };
                this.dialogFormVisible=true;
            },
            updateStream (model) {
                this.streams = this.streams.map(function (item) {
                    if (item.id === model.id) {
                        return model;
                    }
                    return item;
                })
            },
            getTrackingLink (model) {
                this.dialogLinkVisible = true;
                this.selectedItem = {
                    id: model.id,
                    macros: model.macros,
                    tracking_link: model.tracking_link
                };
            },
            restore (item) {
                this.$axios.patch('/streams/' + item.id + '?expand=landings,offer', { restore: 1 }).then(() => {
                    this.getStreams();
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>
